import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Loading from "../UI/Loading/Loading";
import Swiper from "../Swiper/Swiper";
import SwiperSlide from "../Swiper/SwiperSlide/SwiperSlide";
import SkuCard from "../SkuCard/SkuCard";
import classes from "./SkusSlider.module.css";

const SkusSlider = (props) => {
  const { className, isLoading, skus, title } = props;
  const skusSliderRef = useRef();

  useEffect(() => {
    if (skusSliderRef.current) {
      const { width } = skusSliderRef.current.getBoundingClientRect();
      skusSliderRef.current.style.setProperty("--slider-width", `${width}px`);
    }
  }, []);

  return (
    <section
      className={classNames(classes["skus-slider"], className)}
      ref={skusSliderRef}
    >
      {isLoading ? (
        <Loading className={classes["skus-slider__loading"]} />
      ) : (
        skus.length > 0 && (
          <div className={classes["skus-slider__swiper-container"]}>
            <h2 className={classes["skus-slider__title"]}>{title}</h2>
            <Swiper
              className={classes["skus-slider__swiper"]}
              paginationClassName={classes["skus-slider__swiper-pagination"]}
              numberOfSlides={skus.length}
              spaceBetween={50}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
                1280: {
                  slidesPerView: 4,
                },
              }}
            >
              {skus.map((sku, index) => (
                <SwiperSlide
                  key={index}
                  className={classes["skus-slider__swiper-slide"]}
                  lazy="true"
                >
                  <SkuCard
                    className={classes["skus-slider__sku-card"]}
                    id={sku.id}
                    imageUrl={sku.imageUrl}
                    brandName={sku.skuBrand}
                    name={sku.commercialName}
                    price={sku.suggestedSellingPrice}
                    isIncludedInBundles={sku.isIncludedInBundle}
                    availableQuantity={sku.quantity}
                    isCartRuleApplied={sku.isCartRuleApplied}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )
      )}
    </section>
  );
};

export default SkusSlider;

SkusSlider.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  skus: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      commercialName: PropTypes.string,
      skuBrand: PropTypes.string,
      suggestedSellingPrice: PropTypes.number,
      quantity: PropTypes.number,
      imageUrl: PropTypes.string,
    })
  ),
};
